import { Entitlements, ResourceVm } from 'qp-ui-interface';

export const WATCH_NOW = 'button.watchNow';
export const SIGN_IN = 'button.signIn';
export const NOT_AVAILABLE = 'button.notAvailable';

/**
 * Check if the content entitlements includes some free package
 *
 * @param entitlement
 * @returns
 */
export const isFreeContentByEntitlements = (entitlement: Entitlements[]): boolean => {
  return !!entitlement.find((ent: Entitlements) => ent.subscriptionPackage?.find((sub) => sub.includes(':free') || sub.endsWith('free')));
};

/**
 * Check if the user entitlement is included in the content entitlement
 * if it is true, the content is not blocked
 * if not, the content is blocked
 * @param userEntitlements
 * @param contentEntitlements
 * @returns
 */
export const isBlockedContent = (userEntitlements: string[], contentEntitlements: Entitlements[]): boolean => {
  if (isFreeContentByEntitlements(contentEntitlements)) return false;
  if (contentEntitlements.length === 0) return true;
  if (!contentEntitlements[0].subscriptionPackage) return true;
  return !userEntitlements?.length || !contentEntitlements[0].subscriptionPackage.some((sp) => userEntitlements.includes(sp));
};

/** TODO fix details btn
 * Returns the button text to be displayed in details page
 *
 * @param contentEntitlement Content entitlement
 * @param isLoggedIn User logged status
 * @param contentType Content Type
 * @param freeFirstEpisode First episode of series is free
 * @returns Text to display in details page button.
 */
export const getDetailsButton = (resource: ResourceVm, userEntitlements: string[], isLoggedIn: boolean): string => {
  const isFree = isFreeContentByEntitlements(resource.entitlement);
  if (isFree) {
    return WATCH_NOW;
  }
  const isBlocked = isBlockedContent(userEntitlements, resource.entitlement);
  if (isBlocked && !isLoggedIn) {
    return SIGN_IN;
  }
  // Check if content is free
  if (isBlocked) {
    return NOT_AVAILABLE;
  }
  return WATCH_NOW;
};
